import { useTranslation } from "react-i18next";
import style from "./NotActiveSession.module.css";
import AskAiAbout from "../askAiAbout/AskAiAbout";
import Icon from "@/ui/icon/Icon";

function NotActiveSession() {
	const { t } = useTranslation();

	return (
		<div className={style.notActiveSession}>
			<div className={style.aiAvatar}>
				<Icon icon="fa-user-robot" />
			</div>
			<div className={style.info}>
				<h2>{t("ai:assistant.name")}</h2>
				<p>{t("ai:notActiveSession.intro")}</p>
				<AskAiAbout />
			</div>
		</div>
	);
}

export default NotActiveSession;
